import * as React from "react";
import { ArrowRight, FileText, Scale, ShieldCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
const services = [{
  title: "Partnership attiva",
  description: "Collaboriamo con clienti e professionisti come partner, unendo competenze e prospettive per generare valore, innovazione e miglioramento continuo.",
  icon: Scale,
  link: "/LegalTopicsOverviewPage"
}, {
  title: "Side-by-side support",
  description: "Ci poniamo al fianco del cliente, ascoltando con attenzione e traducendo i suoi bisogni in soluzioni legali concrete, comprensibili e realmente utili.",
  icon: FileText,
  link: "/ConsultingPage"
}, {
  title: "Compliance business-focused",
  description: "Rendiamo accessibili norme complesse e stratificate, trasformandole in indicazioni operative semplici e orientate al business.",
  icon: ShieldCheck,
  link: "/EntityResponsibilityPage"
}];
export default function Cards() {
  return <section id="cards" className="dark bg-background py-[120px]">
      <div className="container mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <h2 className="mb-12 font-sans tracking-tighter text-foreground !text-6xl !font-light">                                   Mission</h2>
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <Card key={i} data-index={i} className="border-white/10 bg-card/40 backdrop-blur-md transition-colors duration-300 hover:bg-card/60">
                <CardHeader>
                  <div className="mb-4 flex size-12 items-center justify-center rounded-lg bg-primary/20">
                    <Icon className="size-6 text-primary" />
                  </div>
                  <CardTitle className="font-sans text-xl font-semibold text-foreground !text-left">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="flex-grow">
                  <CardDescription className="font-sans text-base font-normal leading-relaxed text-muted-foreground !text-justify">
                    {service.description}
                  </CardDescription>
                </CardContent>
                <CardFooter>
                  <Button variant="link" className="h-auto p-0 font-sans text-primary hover:text-primary/80" asChild>
                    
                  </Button>
                </CardFooter>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}